import React from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { noop } from '@adsk/alloy-react-helpers';
import { useLocale } from '@adsk/alloy-react-locale';
import Modal from '@adsk/alloy-react-modal';

import { entityShape, pluginShape } from './helpers/propTypes';

const RemoveConfirmationModal = ({
  plugin,
  entity,
  container,
  closeConfirmRemoveModal,
  onRemove,
  isRemoving,
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const show = !!entity && !!plugin;

  const Title = plugin?.CustomRemoveEntityModalTitle;
  const Content = plugin?.CustomRemoveEntityModalContent;

  return (
    <Modal
      open={show}
      onClose={isRemoving ? noop : closeConfirmRemoveModal}
      container={container}
      size={Modal.SIZES.SMALL}
      height="auto"
    >
      <Modal.Header
        style={{
          borderBottom: 0,
        }}
      >
        {Title ? <Title entity={entity} /> : T.translate('REMOVE_LINK_TITLE')}
        <Modal.Close onClick={closeConfirmRemoveModal} disabled={isRemoving} />
      </Modal.Header>
      <Modal.Body>
        {Content ? (
          <Content entity={entity} />
        ) : (
          T.translate('REMOVE_LINK_MESSAGE')
        )}
      </Modal.Body>
      <Modal.Footer disableBorder>
        <Button
          style={{
            marginRight: 8,
          }}
          onClick={closeConfirmRemoveModal}
          disabled={isRemoving}
        >
          {T.translate('CANCEL')}
        </Button>
        <Button
          variant={Button.VARIANTS.PRIMARY}
          onClick={onRemove}
          loading={isRemoving}
          alert={true}
        >
          {T.translate('REMOVE')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

RemoveConfirmationModal.propTypes = {
  /** The plugin to use to render the group */
  plugin: pluginShape,
  /** The entity we want to remove */
  entity: entityShape,
  /** Handler for closing the modal */
  closeConfirmRemoveModal: PropTypes.func,
  /** Handler to remove entity relationship */
  onRemove: PropTypes.func.isRequired,
  /** Whether we're currently in removing process */
  isRemoving: PropTypes.bool,
  /** A container to attach the modal to */
  container: PropTypes.object,
};

export default RemoveConfirmationModal;
